









































import { clone, chunk, flatten } from 'lodash';
import {
    PosWaypoint,
    PosWaypointType,
    PosSourceType,
    PosRoute,
} from 'gl-ms-positions';
import HereMarker from '@/components/common/map/marker.vue';
import HerePolyline from '@/components/common/map/polyline.vue';
import {
    getSingleMarkerPosition,
    zoomToRadius,
} from '@/components/common/map/helpers';
import positions from '@/services/positions';
import {
    ACTION_SET_WAYPOINT_BY_INDEX,
    ACTION_DELETE_WAYPOINT,
    ACTION_NEW_ROUTE,
} from '../../../../store/modules/planning';
import { getIcon } from '../../../../helpers';

const RESOLUTION: any = {
    1: 50312, 2: 25156, 3: 12578, 4: 6289, 5: 3145, 6: 1300, 7: 786, 8: 393, 9: 197, 10: 98, 11: 49, 12: 25, 13: 12, 14: 6, 15: 3, 16: 2, 17: 1, 18: 1, 19: 1, 20: 1, 21: 1, 22: 1, 23: 1,
};

export default {
    data() {
        return {};
    },
    components: {
        HereMarker,
        HerePolyline,
    },
    props: [
        'route',
        'originalRoute',
        'routeChanged',
        'waypoints',
        'map',
        'group',
        'behaviour',
        'lineColor',
        'shadowColor',
    ],
    computed: {
        hasRoute(this: any) {
            return Boolean(this.route);
        },
        hasOriginalRoute(this: any) {
            return Boolean(this.originalRoute);
        },
        trace(this: any) {
            if (this.route) {
                return flatten(this.route.geometry.coordinates);
            }

            return [];
        },
        originalTrace(this: any) {
            if (this.originalRoute) {
                return flatten(this.originalRoute.geometry.coordinates);
            }

            return [];
        },
    },
    methods: {
        getWaypointIcon(this: any, item: PosWaypoint) {
            return getIcon(item);
        },
        getBoundingBox(this: any) {
            if (this.map.getViewModel().getLookAtData().bounds) {
                const { bounds } = this.map.getViewModel().getLookAtData();
                if (bounds) {
                    const topLeft = bounds.getBoundingBox().getTopLeft();
                    const bottomRight = bounds
                        .getBoundingBox()
                        .getBottomRight();
                    return `${topLeft.lat},${topLeft.lng};${bottomRight.lat},${bottomRight.lng}`;
                }
            }

            return '';
        },

        getResolution(this: any) {
            const zoom = parseInt(this.map.getZoom(), 10);
            return `${RESOLUTION[zoom]}:${RESOLUTION[zoom]}`;
        },
        async drag(
            this: any,
            point: H.geo.Point,
            pointFrom: H.geo.Point,
            trace: number[],
        ) {
            // waypoint position
            const position: number = getSingleMarkerPosition(
                pointFrom,
                trace,
                this.waypoints,
            );
            const waypoints: PosWaypoint[] = clone(this.waypoints);
            const currentPoint: PosWaypoint = {
                type: PosWaypointType.DRAG,
                transitRadius: zoomToRadius(parseInt(this.map.getZoom(), 10)),
                geometry: {
                    coordinates: [point.lng, point.lat],
                },
                source: PosSourceType.WEB,
            };

            waypoints.splice(position, 0, currentPoint);

            // Performe the query
            const res: PosRoute[] = await positions.drag(waypoints, {
                viewbounds: this.getBoundingBox(),
                resolution: this.getResolution(),
            });

            if (res[0].geometry.coordinates) {
                this.$refs.route.updateRoute(
                    flatten(res[0].geometry.coordinates),
                );
            }
        },
        async dragend(this: any, point: H.geo.Point, trace: number[]) {
            const position: number = getSingleMarkerPosition(
                point,
                trace,
                this.waypoints,
            );

            const currentPoint: PosWaypoint = {
                type: PosWaypointType.DRAG,
                transitRadius: zoomToRadius(parseInt(this.map.getZoom(), 10)),
                geometry: {
                    coordinates: [point.lng, point.lat],
                },
                label: `${point.lat}${point.lng}`,
                source: PosSourceType.WEB,
            };

            this.$emit('recalculateRoute', {
                item: currentPoint,
                index: position,
            });
        },

        async removeMarker(this: any, item: PosWaypoint) {
            if (item.type === PosWaypointType.DRAG) {
                this.$emit('removeMarker', item);
            }
        },
    },
};
